import { useReveal } from "../../hooks/useReveal";

const PEN = "https://images.pexels.com/photos/261705/pexels-photo-261705.jpeg";

const pillars = [
  {
    n: "I.",
    title: "Indipendenza",
    text: "Nessun mandato di banca o SGR. Nessuna provvigione su prodotti. La mia analisi è libera da qualsiasi conflitto d'interesse strutturale. Mi pagano i clienti, non i prodotti: una parcella trasparente, dichiarata in anticipo, allineata al servizio e non al volume.",
  },
  {
    n: "II.",
    title: "Confronto periodico",
    text: "Ogni decisione viene presa in accordo con il cliente. Non si agisce finché non hai compreso a fondo i benefici delle scelte proposte e perché, proprio in quel momento, quella scelta è tra le migliori che possiamo prendere per il tuo caso specifico.",
  },
  {
    n: "III.",
    title: "Costante ricerca",
    text: "Il mondo della finanza è in continua evoluzione. Gli studi che conduco sono alla ricerca costante di soluzioni più efficienti ed efficaci, perché il tuo patrimonio resti al passo con i tempi — e li anticipi, dove possibile.",
  },
  {
    n: "IV.",
    title: "Evidenza",
    text: "Le decisioni nascono da dati, ricerca accademica e analisi quantitativa. Niente previsioni, niente moda finanziaria: processi ripetibili, misurabili e giustificabili in ogni momento.",
  },
];

export const Approccio = () => {
  const r1 = useReveal();
  const r2 = useReveal();

  return (
    <section
      id="approccio"
      data-testid="approccio-section"
      className="bg-navy text-ivory py-20 md:py-28 relative overflow-hidden border-t border-ivory/10"
    >
      <div className="container-editorial grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-start">
        <div ref={r1} className="reveal lg:col-span-5 lg:sticky lg:top-32">
          <p className="overline text-goldSoft mb-6">Il mio approccio</p>
          <h2 data-testid="approccio-title" className="display-2 text-ivory mb-8">
            Quattro principi.<br />
            <em className="italic text-goldSoft">Senza eccezioni.</em>
          </h2>
          <p className="lede text-ivory/70 max-w-md">
            Una metodologia austera, costruita su trasparenza, dialogo, aggiornamento
            ed evidenza. Tutto ciò che faccio — e tutto ciò che non faccio — discende
            da qui.
          </p>

          <div className="mt-12 img-zoom border border-ivory/15 hidden lg:block">
            <img
              src={PEN}
              alt="Penna stilografica su carta — pianificazione patrimoniale"
              className="w-full h-72 object-cover opacity-90"
            />
          </div>
        </div>

        <div ref={r2} className="reveal lg:col-span-7 space-y-px bg-ivory/10">
          {pillars.map((p, i) => (
            <div
              key={p.n}
              data-testid={`pillar-${i}`}
              className="bg-navy py-8 md:py-10 px-6 md:px-10 border-t border-ivory/15 first:border-t-0 grid grid-cols-12 gap-6 hover:bg-navySoft transition-colors duration-500"
            >
              <div className="col-span-2 md:col-span-2">
                <span className="font-serif text-3xl md:text-4xl text-goldSoft">{p.n}</span>
              </div>
              <div className="col-span-10 md:col-span-10">
                <h3 className="font-serif text-2xl md:text-3xl mb-3">{p.title}</h3>
                <p className="text-ivory/70 leading-relaxed max-w-xl">{p.text}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
